import { render } from "./ModalLoader.vue?vue&type=template&id=09d8c61f&scoped=true"
import script from "./ModalLoader.vue?vue&type=script&lang=js"
export * from "./ModalLoader.vue?vue&type=script&lang=js"

import "./ModalLoader.vue?vue&type=style&index=0&id=09d8c61f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d8c61f"]])

export default __exports__